<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">From Lagos to London</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#disclaimer">Disclaimer</a></li>
<li id="toc-li-6"><span href="#/text/ch006#foreword" title="Link target outside of Sample">Foreword</span></li>
<li id="toc-li-7"><span href="#/text/ch007#introduction" title="Link target outside of Sample">Introduction</span></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-1-a-cold-welcome-arriving-in-the-uk" title="Link target outside of Sample">Chapter 1: A Cold
                Welcome: Arriving in the UK</span>
<ol class="toc">
<li id="toc-li-9"><span href="#/text/ch008#determined-to-be-different-pursuing-a-dream" title="Link target outside of Sample">Determined To
                        Be Different: Pursuing a Dream</span></li>
<li id="toc-li-10"><span href="#/text/ch008#life-lessons" title="Link target outside of Sample">Life Lessons</span></li>
</ol>
</li>
<li id="toc-li-11"><span href="#/text/ch009#chapter-2-nurturing-a-generation-of-achievers" title="Link target outside of Sample">Chapter 2: Nurturing
                a Generation of Achievers</span>
<ol class="toc">
<li id="toc-li-12"><span href="#/text/ch009#emilias-inspirational-wisdom" title="Link target outside of Sample">Emilia’s Inspirational
                        Wisdom</span></li>
<li id="toc-li-13"><span href="#/text/ch009#turning-dreams-into-reality" title="Link target outside of Sample">Turning Dreams into
                        Reality</span></li>
<li id="toc-li-14"><span href="#/text/ch009#life-lessons-1" title="Link target outside of Sample">Life Lessons</span></li>
</ol>
</li>
<li id="toc-li-15"><span href="#/text/ch010#chapter-3-the-journey-begins-from-independence-to-entrepreneurship" title="Link target outside of Sample">Chapter 3: The
                Journey Begins: From Independence to Entrepreneurship</span>
<ol class="toc">
<li id="toc-li-16"><span href="#/text/ch010#the-initial-steps" title="Link target outside of Sample">The Initial Steps</span></li>
<li id="toc-li-17"><span href="#/text/ch010#planning" title="Link target outside of Sample">Planning</span></li>
<li id="toc-li-18"><span href="#/text/ch010#change-of-use" title="Link target outside of Sample">Change of Use</span></li>
<li id="toc-li-19"><span href="#/text/ch010#life-lessons-2" title="Link target outside of Sample">Life Lessons</span></li>
</ol>
</li>
<li id="toc-li-20"><span href="#/text/ch011#chapter-4-from-care-support-worker-to-care-home-owner-turning-dreams-into-reality" title="Link target outside of Sample">Chapter
                4: From Care Support Worker to Care Home Owner: Turning Dreams into Reality</span>
<ol class="toc">
<li id="toc-li-21"><span href="#/text/ch011#quick-takeaways" title="Link target outside of Sample">Quick Takeaways</span></li>
<li id="toc-li-22"><span href="#/text/ch011#tips-for-securing-residential-home-supported-living-accommodation" title="Link target outside of Sample">Tips
                        for Securing Residential Home/ Supported Living Accommodation</span></li>
</ol>
</li>
<li id="toc-li-23"><span href="#/text/ch012#chapter-5-closure-of-the-residential-home-business-transition-into-real-estate" title="Link target outside of Sample">Chapter
                5: Closure of the Residential Home Business: Transition into Real Estate</span>
<ol class="toc">
<li id="toc-li-24"><span href="#/text/ch012#moving-into-real-estate" title="Link target outside of Sample">Moving into Real Estate</span></li>
<li id="toc-li-25"><span href="#/text/ch012#the-challenge" title="Link target outside of Sample">The Challenge</span></li>
<li id="toc-li-26"><span href="#/text/ch012#premature-gratification" title="Link target outside of Sample">Premature Gratification</span></li>
<li id="toc-li-27"><span href="#/text/ch012#building-generational-wealth-through-real-estate" title="Link target outside of Sample">Building
                        Generational Wealth Through Real Estate</span></li>
<li id="toc-li-28"><span href="#/text/ch012#life-lessons-3" title="Link target outside of Sample">Life Lessons</span></li>
</ol>
</li>
<li id="toc-li-29"><span href="#/text/ch013#chapter-6-fundamental-business-principles-ignorance-is-not-bliss" title="Link target outside of Sample">Chapter 6:
                Fundamental Business Principles: Ignorance Is Not Bliss</span>
<ol class="toc">
<li id="toc-li-30"><span href="#/text/ch013#life-lessons-4" title="Link target outside of Sample">Life Lessons</span></li>
</ol>
</li>
<li id="toc-li-31"><span href="#/text/ch014#chapter-7-navigating-financial-turbulence-the-beginning-of-my-property-investment-journey" title="Link target outside of Sample">Chapter
                7: Navigating Financial Turbulence: The Beginning of My Property Investment Journey</span></li>
<li id="toc-li-32"><span href="#/text/ch015#chapter-8-the-high-cost-of-ambition-balancing-health-wealth-and-well-being" title="Link target outside of Sample">Chapter
                8: The High Cost of Ambition: Balancing Health, Wealth, and Well-Being</span>
<ol class="toc">
<li id="toc-li-33"><span href="#/text/ch015#life-lessons-5" title="Link target outside of Sample">Life Lessons</span></li>
</ol>
</li>
<li id="toc-li-34"><span href="#/text/ch016#chapter-9-from-breakdown-to-breakthrough-unleashing-your-inner-warrior" title="Link target outside of Sample">Chapter 9:
                From Breakdown to Breakthrough: Unleashing Your Inner Warrior</span>
<ol class="toc">
<li id="toc-li-35"><span href="#/text/ch016#life-lessons-6" title="Link target outside of Sample">Life Lessons</span></li>
<li id="toc-li-36"><span href="#/text/ch016#further-life-lessons" title="Link target outside of Sample">Further Life Lessons</span></li>
</ol>
</li>
<li id="toc-li-37"><span href="#/text/ch017#chapter-10-closing-thoughts-life-beyond-expectations-inspiring-others" title="Link target outside of Sample">Chapter 10:
                Closing Thoughts Life Beyond Expectations: Inspiring Others</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?178122c2